export default __webpack_public_path__ + "static/media/section3_2_1_sc.64abf383.png";